module.exports = " <div class=post-webwidget-v2-player-layout :class=layoutClassList _v-5a1e986e=\"\"> <div class=post-webwidget-v2-player-layout-top _v-5a1e986e=\"\"> <slot name=top-half _v-5a1e986e=\"\"></slot> </div> <div class=post-webwidget-v2-player-layout-bottom _v-5a1e986e=\"\"> <slot name=bottom-half _v-5a1e986e=\"\"></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5a1e986e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/v2-components/V2PlayerLayout.vue
// module id = 326
// module chunks = 0